import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
} from '@angular/core';
import { Observable } from 'rxjs';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SelectDef, ControlType } from '@domgen/dgx-fe-dynamic-form-builder';
import { distinctUntilChanged, pluck } from 'rxjs/operators';

@Component({
  selector: 'sky-ui-category-form',
  templateUrl: './category-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkyUiCategoryFormComponent {
  public field = {} as SelectDef;
  public formGroup = new UntypedFormGroup({
    category: new UntypedFormControl(''),
  });

  @Input() set categories(categories: string[]) {
    this.getSelectField(categories);
  }
  @Output() formChanges: Observable<string> = this.formGroup.valueChanges.pipe(
    pluck('category'),
    distinctUntilChanged()
  );

  private getSelectField(categories: string[]) {
    this.field = {
      controlType: ControlType.SELECT,
      controlName: 'category',
      validators: [],
      label: { text: 'Choose device' },
      placeholder: 'Select',
      options: categories.sort((a, b) => a.localeCompare(b)),
    };
  }
}
